module.exports = __webpack_public_path__ + "media/common/icon-weather-sunny-daytime-be3ba403.svg";